import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import {
  ASSIGN_UPDATE_TEMPLATE,
  get_project_id,
  get_token,
  UPLOAD_TEMPLATE_URL,
  GET_DOCUMENT_TYPE_URL,
} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import { validate_file, validate_non_empty_string } from "@/utils/validations/validate_inputs";
import axios from 'axios';

export default {
  name: 'UploadTemplate',
  mixins: [alert_mixin],
  components: {
    NavigationBackButton
  },
  data: () => ({
    preview_url: null,
    is_previewable: false,
    selected_file: null,
    project_id: get_project_id(),
    template_name: '',
    template_description: '',
    upload_loading: false,
    template_types: [],
    selected_template_type: ''
  }),

  mounted() {
    this.fetch_template_types();
  },

  methods: {
    async handle_file_selection(evt) {
      const file = evt.target.files[0];
      if (!file) {
        this.clear_file_selection();
        return;
      }

      //Enforce PDF only
      const extension = file.name.split('.').pop().toLowerCase();
      if (extension !== 'pdf') {
        this.show_error('Only PDF files are allowed');
        this.clear_file_selection();
        evt.target.value = '';
        return;
      }

      const validation = await validate_file(file);
      if (!validation.valid) {
        this.show_error(validation.error);
        this.clear_file_selection();
        evt.target.value = '';
        return;
      }

      this.selected_file = file;
      this.handle_file_preview(file);
    },

    fetch_template_types() {
      axios.get(GET_DOCUMENT_TYPE_URL, {
        headers: { Authorization: `Token ${get_token()}` }
      })
        .then(response => {
          this.template_types = response.data.data;
        })
        .catch(() => {
          this.show_error('Could not load template types. Please refresh.');
        });
    },

    clear_file_selection() {
      if (this.preview_url) {
        URL.revokeObjectURL(this.preview_url);
      }
      this.preview_url = null;
      this.is_previewable = false;
      this.selected_file = null;
    },

    handle_file_preview(file) {
      const previewable_types = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'txt', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
      const extension = file.name.split('.').pop().toLowerCase();
      this.is_previewable = previewable_types.includes(extension);
      this.preview_url = URL.createObjectURL(file);
    },

    async upload_template() {
      if (!this.selected_file) {
        this.show_error('Please select a file to upload');
        return;
      }
      if (!validate_non_empty_string(this.template_name)) {
        this.show_error('Please enter a valid template name');
        return;
      }

      this.upload_loading = true;

      const form_data = new FormData();
      form_data.append('template', this.selected_file);
      form_data.append('template_name', this.template_name);
      form_data.append('template_description', this.template_description);
      form_data.append('project_id', this.project_id);
      form_data.append('type', this.selected_template_type);

      try {
        const response = await axios.post(UPLOAD_TEMPLATE_URL, form_data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Token ${get_token()}`
          }
        });
        this.$router.push(this.$route.query.return_path || '/view_template');
        this.$nextTick(() => {
          this.show_success('Template uploaded successfully');
        });
        if (this.$route.query.auto_assign) {
          try {
            await axios.post(
              ASSIGN_UPDATE_TEMPLATE,
              {
                template_id: response.data.data.id,
                entity_type_id: this.$route.query.entity_type_id,
                is_assigned: true
              },
              {
                headers: {
                  Authorization: `Token ${get_token()}`
                }
              }
            );
          } catch (assign_error) {
            console.error('Auto-assignment failed silently', assign_error);
          }
        }
      } catch (error) {
        this.$router.push(this.$route.query.return_path || '/view_template');
        this.$nextTick(() => {
          let error_msg = 'Upload failed';
          if (error.response) {
            error_msg = error.response.data?.data ||
              error.response.data?.message ||
              JSON.stringify(error.response.data);
          } else {
            error_msg = error.message;
          }
          this.show_error(error_msg);
        });
      } finally {
        this.upload_loading = false;
      }
    }
  },

  beforeDestroy() {
    this.clear_file_selection();
  }
};